import moment from './moment'

import constants from '../../config/constants'

/**
 * Format date from backEnd format to the frontEnd format
 * @param {String} date
 * @returns {String}
 */
export default date =>
  moment(date, constants.backEndDateFormat, true).format(
    constants.frontEndDateFormat
  )
